import { useEffect, useState } from "react";

import { SnowplowTracker } from "@/helpers/snowplow";

/**
 * Returns the Snowplow user id, and renders again each time the id is set.
 */
export const useSnowplowUserId = (): string | undefined => {
  const [userId, setUserIdState] = useState(() => SnowplowTracker.userId);

  useEffect(() => {
    const syncUserId = () => setUserIdState(SnowplowTracker.userId);
    // The id can arrive between the render and this effect.
    syncUserId();
    return SnowplowTracker.subscribeToUserId(syncUserId);
  }, []);

  return userId;
};
